export default __webpack_public_path__ + "static/media/kalyani_dark.0da412ff.png";